<template>
  <div class="header__container" :class="{'header__container--h1': isPageHeading}">
    <div class="header__subheading" v-if="subheading">{{subheading}}</div>
    <h1 v-if="isPageHeading" class="header__heading header__heading--h1" :class="{'header__heading--secondary': secondaryHeadingStyle}">{{heading}}</h1>
    <h2 v-if="!isPageHeading" class="header__heading header__heading--h2" :class="{'header__heading--secondary': secondaryHeadingStyle}">{{heading}}</h2>
    <div class="header__article-info" v-if="readTime || (tags && tags.length)">
      <div class="header__read-time-container" v-if="readTime">
        <img class="header__read-time-icon" src="/images/icons/alarm.svg" />
        <span class="header__read-time">{{readTime}}</span>
      </div>
      <div class="header__tags" v-if="tags && tags.length">
        <img class="header__tag-icon" src="/images/icons/local-offer.svg" />
        <span class="header__tag" v-for="(tag, i) in tags" :key="tag + i">{{tag.text}}<template v-if="i < tags.length - 1">, </template></span>
      </div>
    </div>
    <div class="header__copy" v-html="copy" v-if="copy"></div>
    <div class="header__slot">
      <slot />
    </div>
  </div>
</template>
        

<script>
  export default {
    name: 'w-header',
    props: {
      secondaryHeadingStyle: {
        type: Boolean,
        default: false,
      },
      isPageHeading: {
        type: Boolean,
        default: false,
      },
      heading: String,
      subheading: String,
      copy: String,
      readTime: String,
      tags: Array,
    },
  }
</script>

<style lang="scss" scoped>
.header {
  &__container {
    text-align: center;
    &--h1 {
      margin-top: $spacing-lg;
      text-align: left;
      @include tablet-portrait {
        margin-top: $spacing-xl;
      }
    }
    @include tablet-portrait {
      text-align: left;
    }
  }
  &__heading {
    color: $secondary;
    line-height: 1.3;
    margin-bottom: $spacing-sm;
    @include tablet-portrait {
      line-height: 1;
    }
    &--h1 {
      font-size: pxToRem(32);
      font-family: $font-family-heading;
      @include tablet-portrait {
        font-size: pxToRem(62);
      }
    }
    &--h2 {
      font-size: pxToRem(24);
      @include tablet-portrait {
        font-size: pxToRem(36)
      }
    }
    &--secondary {
      color: $primary;
    }
  }
  &__subheading {
    color: $gray;
    font-style: italic;
    font-size: pxToRem(14);
    line-height: 1;
    @include tablet-portrait {
      font-size: pxToRem(20);
      margin-bottom: $spacing-sm;
    }
  }
  &__article-info {
    margin: $spacing-sm 0;
    @include tablet-portrait {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      margin: $spacing-sm 0 $spacing-md;
    }
  }
  &__read-time-container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex: 1 0 0;
  }
  &__read-time {
    color: $secondary;
    font-weight: bold;
    margin-left: $spacing-sm;
    white-space: nowrap;
  }
  &__tags {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    flex: 1 1 100%;
    margin: $spacing-sm 0 0;
    @include tablet-portrait {
      margin: 0 0 0 $spacing-lg;
    }
  }
  &__tag-icon {
    margin-right: $spacing-sm;
  }
  &__tag {
    color: $secondary;
    font-weight: bold;
    margin-right: 5px;
  }
  &__copy {
    font-size: pxToRem(18);
    line-height: 1.5;
    margin-bottom: $spacing-sm;
    color: $gray;
    @include tablet-portrait {
      line-height: 1.3;
    }
  }
  &__icons {
    @include tablet-portrait {
      display: flex;
      flex-wrap: wrap;
      margin-top: $spacing-lg;
    }
  }
  &__icon-container {
    margin: $spacing-sm 0;
    @include tablet-portrait {
      margin: 0 $spacing-lg 0 0;
      &:last-of-type {
        margin: 0;
      }
    }
  }
  &__icon {
    max-width: 100%;
  }
}
</style>
